module.exports = "https://qiaozuji-flms-public.cdn.qiaozuji.com/resource/h5/img/activity_img_01.png";